import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=0fec8cfc&scoped=true&"
import script from "./CharacterList.vue?vue&type=script&lang=js&"
export * from "./CharacterList.vue?vue&type=script&lang=js&"
import style0 from "./CharacterList.vue?vue&type=style&index=0&id=0fec8cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec8cfc",
  null
  
)

export default component.exports